import { createStore } from 'vuex';

const store = createStore({
    state: {
       
    },
    mutations: {
    
    },
    actions: {

    }
});

export default store;
